<template>
  <PreviewLayout :item="item" :loading="loading">
    <div>
      <ul
        v-if="style == 'unordered' || style == 'un_ordered'"
        class="p-postEditor__unorderedList"
      >
        <p
          class="p-postEditor__unorderedList--title"
          v-html="previewTitleItem()"
        ></p>
        <li v-for="(listItem, index) in previewListItems()" :key="index">
          <span v-html="listItem"></span>
        </li>
      </ul>
      <ol v-if="style == 'ordered'" class="p-postEditor__orderedList">
        <p
          class="p-postEditor__orderedList--title"
          v-html="previewTitleItem()"
        ></p>
        <li v-for="(listItem, index) in previewListItems()" :key="index">
          <span class="list-number">{{ index + 1 }}</span>
          <span v-html="listItem"></span>
        </li>
      </ol>
    </div>
  </PreviewLayout>
</template>

<script>
import baseTextlintPreview from '@/mixins/base_textlint_preview'
import PreviewLayout from './PreviewLayout'

export default {
  name: 'ListItemPreview',
  components: { PreviewLayout },
  mixins: [baseTextlintPreview],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      titleLintTag: this.textLintAllowTagFormat('title')
    }
  },
  computed: {
    title: function () {
      return this.item.itemableAttributes.title
    },
    listItems: function () {
      return this.item.itemableAttributes.items
    },
    style: function () {
      return this.item.itemableAttributes.style
    },
    lintContent: function () {
      const titleText = `${this.titleLintTag[0]}${this.title}${this.titleLintTag[1]}\n`
      return (
        titleText +
        this.listItems
          .map((item, index) => {
            const tags = this.listTag(index, 'item')
            return `${tags[0]}${item}${tags[1]}\n`
          })
          .join('')
      )
    }
  },
  mounted () {
    this.setLintAction(this.lintContent)

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'PostEditor/UPDATE_ITEM') {
        if (mutation.payload.uuid === this.item.uuid) {
          this.setLintAction(this.lintContent)
          this.$store.commit('TextLintStore/deleteItemLintResult', {
            uuid: this.uuid
          })
          this.lintAction().call()
        }
      }
    })
  },
  methods: {
    listTag (index, item) {
      const tagName = `${index}_${item}`
      return this.textLintAllowTagFormat(tagName)
    },
    previewTitleItem () {
      return this.parseLintContent(this.titleLintTag) || this.title
    },
    previewListItems () {
      return this.listItems.map((item, index) => {
        const content = this.parseLintContent(this.listTag(index, 'item'))
        return content || item
      })
    },
    parseLintContent (tag) {
      const previewContentText = this.previewContent(this.lintContent)
      const re = new RegExp(`${tag[0]}[\\s\\S]*${tag[1]}`, 'g')

      if (previewContentText.match(re)) {
        return previewContentText
          .match(re)
          .pop()
          .replace(tag[0], '')
          .replace(tag[1], '')
      }
    }
  }
}
</script>
